// extracted by mini-css-extract-plugin
module.exports = {"container":"_6c97079b1b--container--1103o","content":"_6c97079b1b--content--2UzSd"};